import { render, staticRenderFns } from "./ClaimItem.vue?vue&type=template&id=b22e5fae&"
import script from "./ClaimItem.vue?vue&type=script&lang=js&"
export * from "./ClaimItem.vue?vue&type=script&lang=js&"
import style0 from "./ClaimItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimItem.vue"
export default component.exports